var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{attrs:{"id":"blur-wrapper"}},[(_vm.subscriptionType || _vm.overrideTest)?_c('router-view',{attrs:{"storeUTMValues":_vm.storeUTMValues}}):_c('div',{staticClass:"flex items-center justify-center w-screen h-screen"},[_c('Loader')],1)],1),_c('portal-target',{attrs:{"name":"overlay"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }